import { Record } from 'immutable';
import { Base } from './base';
import { first } from 'lodash';
import moment from 'moment';
import Image from './image';
import Deal from './deal';
import Schedule from './schedule';

//import { mockApi } from 'ui-utilities';
//
////const posts = [{
  //attributes: [{
    //vendor_id: "576", // Mad taco
    //comment: 'First test post I\'m following'
  //}],
  //id: 1,
  //type: 'posts'
//}, {
  //attributes: [{
    //vendor_id: "576", // Mad Taco
    //comment: 'Second test post I\'m following'
  //}],
  //id: 2,
  //type: 'posts'
//}];

/*var mockApiInstance = new mockApi('posts', ['user_id', 'vendor_id', 'comment']);*/

//function api() {
  //if (!mockApiInstance._store) mockApiInstance.store = store;
  //return mockApiInstance;
/*}*/

export default class Post extends Base(Record({
  id: null,
  vendor_id: null,
  body: null,
  type: 'general',
  inserted_at: null,
  proxies: [Image, Deal, Schedule],
  standalone: false
})) {
  $create() {
    return this.api.post({
      resource: 'posts'
    }, this.api.payload('posts', this));
  }

  $get(id, filter = 'vendor_id', type = 'general', showAll = false) {
    if (this.vendor_id) id = this.vendor_id;

    if (!id) return Promise.resolve({ data: [] });

    let proxies = this.proxies;

    if (this.type === 'general' || type === 'general') proxies = [Image];
    if (this.type === 'special' || type === 'special') proxies = [Image, Schedule];
    if (this.type === 'deal' || type === 'deal') proxies = [Image, Deal, Schedule];

    let allFilter;
    showAll ? allFilter = '&filter[show]=all' : allFilter = '';

    return this.api.get({
      resource: 'posts?filter[' + filter + ']=' + id + '&filter[type]=' + type + allFilter
    })
    .then(res => !this.standalone ? Promise.all(
      [res].concat(res.data.map(v => Promise.all(
        proxies.map(p => this.$proxy(new p({ owner_id: v.id }), v.id, 'posts', showAll))
      )))
    ) : [res])
    .then(res => this.dispatch(this.actions.receiveEntities(first(res).data, 'posts')))
  }

  $delete(id) {
    if (!id) id = this.id;

    return Promise.all([
      this.deal() ? this.deal().$delete() : Promise.resolve('No op'),
      this.image() ? this.image().$delete() : Promise.resolve('No op'),
      this.schedule() ? this.schedule().$delete() : Promise.resolve('No op')
    ])
    .then(res => this.api.delete({
      id: id,
      resource: 'posts'
    }))
    .then(res => this.dispatch(this.actions.clearEntity(this, 'posts')));
  }

  image() {
    return this.state.entities
      .get('images')
      .find(i => i.owner_id === this.id && i.owner_type === 'posts');
  }

  postPicUrl(transformations) {
    const defaultUrl = 'https://res.cloudinary.com/localvore-today/image/upload/v1493998098/profile.png';
    const postPic = this.image();
    const image = new Image({ url: postPic ? postPic.get('url') : defaultUrl });

    return image.withTransformations(transformations);
  }

  schedule(state) {
    if (!state) state = this.state.entities;

    return state
      .get('schedules')
      .find(s => s.owner_id === this.id && s.owner_type === 'posts');
  }

  deal() {
    const schedule = this.schedule();
    const deal = this.state.entities
      .get('deals')
      .find(d => d.post_id === this.id);

    if (schedule && deal) return deal;
  }

  scheduledInFuture() {
    const schedule = this.schedule();
    if (!schedule) return false;
    return moment(schedule.start_date, 'YYYY-MM-DD').isAfter(moment());
  }

  displayType() {
    switch (this.type) {
      case 'general':
        return 'POST';

      default:
        return 'POST';
    }
  }
}



// WEBPACK FOOTER //
// ./src/records/post.js